import { render, staticRenderFns } from "./SelfFiltering.vue?vue&type=template&id=5b6688cb&scoped=true&"
import script from "./SelfFiltering.vue?vue&type=script&lang=js&"
export * from "./SelfFiltering.vue?vue&type=script&lang=js&"
import style0 from "./SelfFiltering.vue?vue&type=style&index=0&id=5b6688cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6688cb",
  null
  
)

export default component.exports